import { Form, Select } from 'antd';
import FormField from './FormField';
import FormWrapper from './FormWrapper';
import AuthenticationSection from './AuthenticationSection';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import ConnectionTestButton from './ConnectionTestButton';
import type { FieldConfig } from './types';
import type { HttpConfig } from '../../types';
import { transformHttpConfigForTest } from '../../utils/connectionConfigTransformers';
import { useConnectionTest } from '../../hooks/useConnectionTest';

const urlField: FieldConfig = {
    name: 'url',
    label: 'Endpoint URL',
    type: 'url',
    required: true,
    placeholder: 'https://api.example.com/data',
};

interface HttpConfigFormProps {
    onConnectionTestSuccess?: () => void;
}

export default function HttpConfigForm({ onConnectionTestSuccess }: HttpConfigFormProps) {
    const { getConfig, handleTestConnection, isLoading } = useConnectionTest<HttpConfig>(
        transformHttpConfigForTest,
        config => Boolean(config?.url),
        onConnectionTestSuccess
    );

    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            <FormField config={urlField} />
            <Form.Item
                name={['configuration', 'method']}
                label="HTTP Method"
                initialValue="GET"
            >
                <Select>
                    <Select.Option value="GET">GET</Select.Option>
                    <Select.Option value="POST">POST</Select.Option>
                </Select>
            </Form.Item>
            <AuthenticationSection />
            {onConnectionTestSuccess && (
                <ConnectionTestButton
                    getConfig={getConfig}
                    testConnection={handleTestConnection}
                    isLoading={isLoading}
                    requiredFieldsMessage="Please enter a valid URL before testing the connection"
                />
            )}
        </FormWrapper>
    );
}
